import Vue from "vue";
import services from "@/http";
import * as types from "./mutation-types";
import axios from "axios";
import moment from "moment";
import { SlaughterProgrammingEventBus } from "@/modules/programacaoAbate/events";
import { cloneDeep } from "lodash";
import { store } from "@/modules/common";

moment.locale("pt-BR");

export const ActionMontaListaDatas = ({ commit }, listaDatas) => {
  commit(types.SET_LISTA_DATAS, listaDatas);
};

export const ActionChangeProgrammingSlaughterSelected = (
  { commit },
  listDates
) => {
  commit(types.SET_PROGRAMMING_SELECTED, listDates);
  commit(types.SET_LISTA_DEMANDAS, []);
};

export const ActionSetPlantasAbate = ({ commit }, plantasAbate) => {
  commit(types.SET_PLANTAS_ABATE, plantasAbate);
};

export const ActionSetMunicipios = ({ commit }, municipios) => {
  commit(types.SET_MUNICIPIOS, municipios);
};

export const ActionInsertProgrammingSlaughter = (
  { commit, dispatch },
  programming
) => {
  commit(types.SET_LOADING, true);
  return services.programacaoAbate
    .insertProgrammingSlaughter(programming)
    .then((resp) => {
      if (resp.data[0].data != null) {
        dispatch(
          "ActionLoadProgramacaoAbate",
          resp.data[0].data.idProgramacaoAbate
        );
      } else {
        commit(types.SET_LOADING, false);
      }
    });
};

export const ActionEditProgrammingSlaughter = (
  { commit, dispatch },
  programming
) => {
  const {id, dtInicioAbate, dtFimAbate} = programming
  return services.programacaoAbate.updateProgrammingSlaughter({
    id: id
  }, {
    dtInicioAbate: dtInicioAbate,
    dtFimAbate: dtFimAbate
  });
};

export const ActionVerificaExisteProgramacao = ({
  commit,
  dispatch,
  state,
}) => {
  commit(types.SET_LOADING, true);
  const { dtInicioAbate, dtFimAbate } = state.programacaoAbateSelected;
  const params = {
    dt_inicio_abate: dtInicioAbate,
    dt_fim_abate: dtFimAbate,
  };
  return services.programacaoAbate
    .verifyExistsProgrammingSlaughter(params)
    .then((resp) => {
      if (resp.data[0].data != null) {
        dispatch(
          "ActionLoadProgramacaoAbate",
          resp.data[0].data[1].idProgramacaoAbate
        );
      } else {
        dispatch(
          "ActionInsertProgrammingSlaughter",
          state.programacaoAbateSelected
        );
      }
    })
    .catch((error) => {
      // commit(types.SET_ERROR, error);
      commit(types.SET_LOADING, false);
    });
};

export const prepareDateList = (startDate, endDate) => {
  startDate = moment(startDate);
  endDate = moment(endDate);

  const dateList = [];
  let dayNumber = 1;
  for (
    let m = moment(startDate);
    m.diff(endDate, "days") <= 0;
    m.add(1, "days")
  ) {
    dateList.push({
      text: m.format("DD/MM/YYYY"),
      dayText: m.format("DD/MM"),
      semanaText: m.format("dddd"),
      value: `qtDia${dayNumber}`,
    });
    dayNumber++;
  }
  return dateList;
};
export const ActionLoadProgramacaoAbate = ({ commit }, id) => {
  return services.programacaoAbate
    .loadProgramacaoAbate({ id })
    .then((resp) => {
      const data = resp.data[0].data;

      const dateList = prepareDateList(data.dtInicioAbate, data.dtFimAbate);

      commit(types.SET_LISTA_DATAS, dateList);
      commit(types.SET_PROGRAMMING_TITLE, data.nrProgramacaoAbate);
      commit(types.SET_PROGRAMMING_SELECTED, data);
      return data;
    })
    .catch((error) => {
      // commit(types.SET_ERROR, error);
    })
    .finally(() => {
      commit(types.SET_LOADING, false);
    });
};

export const ActionLoadDemands = ({ commit, state }, idProgramacao) => {
  const params = {
    cdProgramacaoAbate: idProgramacao,
  };
  commit(types.SET_LOADING, true);
  return services.programacaoAbate
    .loadProgrammingSlaughterDemands(params)
    .then((resp) => {
      if (resp.data[0].data) {
        let registros = [];
        resp.data[0].data.forEach((entry) => {
          let plantaAbate = state.plantasAbate.find(
            (i) => i.idPlantaAbate == entry.cdPlantaAbate
          );
          if (!plantaAbate) return;
          plantaAbate.nmMunicipio = state.municipios.find(
            (i) => i.idMunicipio == plantaAbate.cdMunicipio
          ).nmMunicipio;
          let demandaPreenchida = true;
          let qtTotalDemanda =
            entry.qtDia1 +
            entry.qtDia2 +
            entry.qtDia3 +
            entry.qtDia4 +
            entry.qtDia5 +
            entry.qtDia6 +
            entry.qtDia7;
          registros.push({
            ...entry,
            plantaAbate,
            demandaPreenchida,
            qtTotalDemanda,
          });
        });

        commit(types.SET_LISTA_DEMANDAS, registros);
        commit(types.SET_DEMAND_SAVED, true);
        commit(types.SET_CAN_EDIT_DEMANDS, false);
        commit(types.SET_LIST_DATES_WITH_DEMAND, registros);
      } else {
        let demandas = [];
        state.plantasAbate.forEach(function (plantaAbate) {
          let nmMunicipio =
            state.municipios.length > 0
              ? state.municipios.find(
                  (x) => x.idMunicipio == plantaAbate.cdMunicipio
                ).nmMunicipio
              : "";
          plantaAbate.nmMunicipio = nmMunicipio;
          let item = {
            plantaAbate: plantaAbate,
            cdPlantaAbate: plantaAbate.idPlantaAbate,
            cdProgramacaoAbate:
              state.programacaoAbateSelected.idProgramacaoAbate,
            qtTotalDemanda: 0,
            demandaPreenchida: false,
          };
          demandas.push(item);
        });
        commit(types.SET_LISTA_DEMANDAS, demandas);
        commit(types.SET_DEMAND_SAVED, false);
      }
    })
    .catch((error) => {
      // commit(types.SET_ERROR, error);
    })
    .finally(() => {
      commit(types.SET_LOADING, false);
    });
};

export const ActionPreencheDemandasVazia = ({ commit }, data) => {
  commit(types.SET_LISTA_DEMANDAS, data);
};

export const ActionPreencheAnimaisDemanda = ({ commit }, item) => {
  commit(types.SET_ANIMAIS_ITEM_DEMANDAS, item);
};

export const ActionInserirDemanda = ({ commit }, demanda) => {
  commit(types.SET_LOADING, true);
  return services.programacaoAbate
    .insertDemanda(demanda)
    .then((resp) => {
      commit(types.SET_LISTA_DEMANDAS, resp.data[0].data);
      commit(types.SET_DEMAND_SAVED, true);
    })
    .catch((error) => {
      // commit(types.SET_ERROR, error);
      commit(types.SET_LOADING, false);
    })
    .finally(() => {
      commit(types.SET_LOADING, false);
    });
};

export const ActionAlterarDemanda = ({ commit }, demanda) => {
  commit(types.SET_LOADING, true);
  return services.programacaoAbate
    .updateDemanda({ id: demanda.idProgramacaoAbateDemanda }, demanda)
    .then((resp) => {
      if (resp.data[0].data) {
        commit(types.SET_DEMAND_SAVED, true);
      }
    })
    .catch((error) => {
      // commit(types.SET_ERROR, error);
    })
    .finally(() => {
      commit(types.SET_LOADING, false);
    });
};

export const ActionInserirDemandaBatch = ({ commit, state }, demandas) => {
  commit(types.SET_LOADING, true);
  return services.programacaoAbate
    .insertDemandaBatch(demandas)
    .then((resp) => {
      let registros = resp.data[0].data.map((entry) => {
        let plantaAbate = state.plantasAbate.find(
          (i) => i.idPlantaAbate == entry.cdPlantaAbate
        );
        plantaAbate.nmMunicipio = state.municipios.find(
          (i) => i.idMunicipio == plantaAbate.cdMunicipio
        ).nmMunicipio;
        let demandaPreenchida = true;
        let qtTotalDemanda =
          entry.qtDia1 +
          entry.qtDia2 +
          entry.qtDia3 +
          entry.qtDia4 +
          entry.qtDia5 +
          entry.qtDia6 +
          entry.qtDia7;
        return { ...entry, plantaAbate, demandaPreenchida, qtTotalDemanda };
      });

      commit(types.SET_LISTA_DEMANDAS, registros);
      commit(types.SET_DEMAND_SAVED, true);
      commit(types.SET_CAN_EDIT_DEMANDS, false);
    })
    .catch((error) => {
      // commit(types.SET_ERROR, error);
      commit(types.SET_LOADING, false);
    })
    .finally(() => {
      commit(types.SET_LOADING, false);
    });
};

export const ActionAlterarDemandaBatch = ({ commit }, demandas) => {
  commit(types.SET_LOADING, true);
  return services.programacaoAbate
    .updateDemandaBatch({}, demandas)
    .then((resp) => {
      if (resp.data[0].data) {
        commit(types.SET_DEMAND_SAVED, true);
        commit(types.SET_CAN_EDIT_DEMANDS, false);
      }
    })
    .catch((error) => {
      // commit(types.SET_ERROR, error);
    })
    .finally(() => {
      commit(types.SET_LOADING, false);
    });
};

export const ActionChangeDemandSaved = ({ commit }, payload) => {
  commit(types.SET_DEMAND_SAVED, payload);
};

export const ActionSetCanEditDemands = ({ commit }, value) => {
  commit(types.SET_CAN_EDIT_DEMANDS, value);
};

export const ActionChangePageBatchsAvaliabe = ({ commit }, page) => {
  commit(types.SET_PAGE_BATCHS_AVALIABLE, page);
};

export const ActionSetExtensionistas = ({ commit }, extensionistas) => {
  commit(types.SET_LIST_EXTENSIONISTAS, extensionistas);
};

export const ActionSetTipoGenero = ({ commit }, tiposGenero) => {
  commit(types.SET_LIST_TIPOS_GENERO, tiposGenero);
};

export const ActionLoadBatchsAvaliable = ({ commit, state }) => {
  let params = {};
  params.dt_projecao = state.listaDatas[0].text;
  params.per_page = state.itemsPerPageBatchsAvaliable;
  params.page = state.pageBatchsAvaliable;
  if (state.listBatchsAlreadyAllocated.length > 0) {
    var lotes_alocados = [];
    state.listBatchsAlreadyAllocated.forEach(function (lote) {
      var recordLote = {
        idLoteProducao: lote.idLoteProducao,
      };
      lotes_alocados.push(recordLote);
    });
    params.lotes_alocados = [lotes_alocados];
  }
  commit(types.SET_LOADING, true);
  return services.programacaoAbate
    .loadBatchsAvaliable(params)
    .then((resp) => {
      if (resp.data[0].data != null) {
        let registros = resp.data[0].data.map((entry) => {
          let extensionista = state.listExtensionistas.find(
            (i) => i.idResponsavelTecnico == entry.cdResponsavelTecnico
          );
          let nmMunicipio = state.municipios.find(
            (i) => i.idMunicipio == entry.jsonEstabelecimento.cdMunicipio
          ).nmMunicipio;
          let dsTipoSexo = state.listTiposGenero.find(
            (i) => i.sgSexo === entry.sgSexo
          ).dsSexo;
          let isEditing = false;
          return {
            ...entry,
            extensionista,
            nmMunicipio,
            dsTipoSexo,
            isEditing,
          };
        });

        commit(types.SET_BATCHS_AVALIABLE, registros);
        commit(types.SET_PAGE_BATCHS_AVALIABLE, state.pageBatchsAvaliable + 1);
        commit(types.SET_PROGRAMACOES_PLANTA, registros);
        return resp;
      }
    })
    .catch((error) => {
      // commit(types.SET_ERROR, error);
      commit(types.SET_LOADING, false);
    })
    .finally(() => commit(types.SET_LOADING, false));
};

export const ActionChangeExibicaoPlantas = ({ commit }, id) => {
  commit(types.SET_EDITING_ITEM_BATCH_AVALIABLE, id);
};

// Slaughter Programming Lots
export const ActionLoadCities = ({ commit, state }) => {
  axios
    .get(process.env.VUE_APP_URL_API_ESTABELECIMENTO + "municipio/")
    .then((response) => {
      commit(types.SET_CITIES, response.data);
    })
    .catch((error) => {
      commit("setSnack", { type: "error", msg: error });
    });
};

export const ActionLoadAvailableLots = (
  { commit, state },
  { cdProgramacaoAbate, cdPlantaAbate }
) => {
  let params = {};

  // Filtros
  params.per_page = 20;
  params.page = state.availableLotsCurrPage[cdPlantaAbate] || 1;

  return services.programacaoAbate
    .loadBatchsAvaliable({
      cdProgramacaoAbate: cdProgramacaoAbate,
      cdPlantaAbate: cdPlantaAbate,
      ...params,
    })
    .then((resp) => {
      if (!resp.data) return;
      if (resp.data.length === 0) return;

      const data = resp.data[0].data;
      const meta = resp.data[0].meta;
      if (!data) return;

      let availableLots = data.map((entry) => {
        const foundCity = state.cities.find(
          (i) => i["idMunicipio"] === entry.jsonEstabelecimento.cdMunicipio
        );
        return {
          ...entry,
          nmCity: foundCity ? foundCity.nmMunicipio : null,
        };
      });

      availableLots = [
        ...(state.availableLots[cdPlantaAbate] || []),
        ...availableLots,
      ];

      commit(types.SET_AVAILABLE_LOTS, {
        cdPlantaAbate: cdPlantaAbate,
        availableLots: availableLots,
      });
      commit(types.SET_AVAILABLE_LOTS_META, {
        cdPlantaAbate: cdPlantaAbate,
        availableLotsMeta: meta,
      });
      commit(types.SET_AVAILABLE_LOTS_CURR_PAGE, {
        cdPlantaAbate: cdPlantaAbate,
        page: (state.availableLotsCurrPage[cdPlantaAbate] || 1) + 1,
      });
      return resp;
    });
};

export const ActionLoadSlaughterPlantEstablishments = ({ commit }) => {
  return services.programacaoAbate
    .loadSlaughterPlantEstablishment()
    .then((res) => {
      if (!res.data) return;
      if (res.data.length === 0) return;

      const data = res.data[0].data;
      const meta = res.data[0].meta;
      if (!data) return;

      commit(types.SET_SLAUGHTER_PLANT_ESTABLISHMENTS, data);
    });
};

export const ActionChangeShowLote = ({ commit }, item) => {
  commit(types.SET_SHOW_LOTES_PLANTA_ABATE, item);
};

export const ActionConfirmarLotes = ({ commit, state }, payload) => {
  const isObjectPayload = payload !== null && typeof payload === "object";
  const status = isObjectPayload ? payload.status : payload;
  const notificarProdutor = isObjectPayload && payload.notificarProdutor !== undefined
    ? payload.notificarProdutor
    : true;

  let rec = {
    cdProgramacaoAbate: state.programacaoAbateSelected.idProgramacaoAbate,
    cdStatusProgramacaoAbate: status,
    blNotificarProdutor: notificarProdutor,
  };
  return services.programacaoAbate.changeStatusProgramacao(rec).then((res) => {
    const data = res.data[0].data;
    commit(types.SET_NEW_STATUS_PROGRAMACAO, status);
  });
};

export const ActionLoadBatchsAllocated = (
  { commit, state, dispatch },
  cdProgramacao
) => {
  const params = {
    cdProgramacaoAbate: cdProgramacao,
  };
  commit(types.SET_LOADING, true);

  return services.programacaoAbate
    .loadBatchsAllocated(params)
    .then((resp) => {
      if (resp.data[0].data) {
        let registros = resp.data[0].data.map((entry) => {
          let extensionista = state.listExtensionistas.find(
            (i) =>
              i.idResponsavelTecnico == entry.loteProducao.cdResponsavelTecnico
          );
          let nmMunicipio = state.municipios.find(
            (i) =>
              i.idMunicipio ==
              entry.loteProducao.jsonEstabelecimento.cdMunicipio
          ).nmMunicipio;
          let dsTipoSexo = state.listTiposGenero.find(
            (i) => i.sgSexo === entry.loteProducao.sgSexo
          ).dsSexo;
          let editarPeso = false;
          let distanciaPlanta = {
            cdEstabelecimento: entry.loteProducao.cdEstabelecimento,
            cdPlantaAbate: entry.cdPlantaAbate,
            dsTipo: "",
            nrValor: "-",
          };
          let checkList = {
            dtConfirmacaoProdutor: null,
          };
          return {
            ...entry,
            extensionista,
            nmMunicipio,
            dsTipoSexo,
            editarPeso,
            distanciaPlanta,
            checkList,
          };
        });

        const sumAllocatedByLots = registros.reduce((acc, curr) => {
          if (!acc[curr.cdLoteProducao]) acc[curr.cdLoteProducao] = 0;
          acc[curr.cdLoteProducao] += curr.qtAnimaisAlocados;
          return acc;
        }, {});

        registros.forEach((item) => {
          const foundLot = state.listBatchsAllocated.find(
            (x) =>
              x.idProgramacaoAbateAlocado === item.idProgramacaoAbateAlocado
          );
          item.loteProducao.qtAnimaisProgramadoAbate -=
            sumAllocatedByLots[item.cdLoteProducao];
          if (foundLot) {
            item.qtAnimaisAlocados = foundLot.qtAnimaisAlocados;
            item.blDeleted = foundLot.blDeleted;
            item.blChanged = foundLot.blChanged;
            item.stDiaAlocado = foundLot.stDiaAlocado
            item.dtAlocado = foundLot.dtAlocado
            item.nrPesoDia = foundLot.nrPesoDia
          }
          dispatch("ActionLoadDistanciaPlantaAbateEstabelecimento", item);
          dispatch("ActionLoadCheckList", item);
        });

        commit(types.SET_LIST_BATCHS_ALLOCATED, registros);
      }
    })
    .catch((error) => {
      // commit(types.SET_ERROR, error);
    })
    .finally(() => {
      commit(types.SET_LOADING, false);
    });
};

export const ActionLoadDistanciaPlantaAbateEstabelecimento = (
  { commit },
  programacaoAbateAlocado
) => {
  const params = {
    cdPlantaAbate: programacaoAbateAlocado.cdPlantaAbate,
    cdEstabelecimento: programacaoAbateAlocado.loteProducao.cdEstabelecimento,
  };
  return services.programacaoAbate
    .loadDistanciaPlantaAbateEstabelecimento(params)
    .then((resp) => {
      if (resp.data[0].data) {
        let result = {
          estabelecimentoPlanta: resp.data[0].data,
          cdProgramacaoAbateAlocado:
            programacaoAbateAlocado.idProgramacaoAbateAlocado,
        };
        commit(types.SET_DISTANCIA_ESTABELECIMENTO_PLANTA, result);
      }
    })
    .catch((error) => {
      // commit(types.SET_ERROR, error);
    });
};

export const ActionChangeEditWeight = ({ commit }, itemLoteAlocado) => {
  commit(types.SET_NEW_VALUE_EDIT_WEIGHT, itemLoteAlocado);
};

export const ActionUpdateProgramacaoAbateAlocado = (
  { commit, state },
  itemAlocado
) => {
  return services.programacaoAbate
    .updateProgramacaoAbateAlocado(
      { id: itemAlocado.idProgramacaoAbateAlocado },
      itemAlocado
    )
    .then((resp) => {
      const data = resp.data[0].data;
    })
    .catch((error) => {
      // commit(types.SET_ERROR, error);
    })
    .finally(() => {
      commit(types.SET_LOADING, false);
    });
};

export const ActionBatchUpdateProgramacaoAbateAlocado = (
  { commit, state },
  updatePayload
) => {
  commit(types.SET_LOADING, true);
  return services.programacaoAbate
    .updateSlaughterProgrammingAllocatedLots(updatePayload)
    .then(() => {
      const listBatchsAllocated = cloneDeep(state.listBatchsAllocated);
      listBatchsAllocated.forEach((alocado) => {
        alocado.blChanged = false;
      });

      Vue.set(state, "listBatchsAllocated", listBatchsAllocated);
    })
    .finally(() => {
      commit(types.SET_LOADING, false);
    });
};

export const ActionChangeQtAnimalsItem = ({ commit, dispatch }, item) => {
  commit(types.SET_NEW_VALUE_QT_ANIMALS_ALLOCATED, item);
  let recAlocado = item.valueLote;
  recAlocado.qtAnimaisAlocados = item.qtAnimais;
  dispatch("ActionUpdateProgramacaoAbateAlocado", recAlocado);
};

export const ActionChangeWeightValueItem = ({ commit, dispatch }, item) => {
  commit(types.SET_NEW_VALUE_WEIGHT_ALLOCATED, item);
  let recAlocado = item.valueLote;
  recAlocado.nrPesoDia = item.nrPeso;
  dispatch("ActionUpdateProgramacaoAbateAlocado", recAlocado);
};

export const ActionDeleteProgramingBatchAllocated = (
  { commit, state },
  alocado
) => {
  const idx = state.listCheckListAlocados.findIndex(
    (item) =>
      item.cdProgramacaoAbateAlocado === alocado.idProgramacaoAbateAlocado
  );
  if (idx > -1) {
    commit(types.REMOVE_LOTE_ALOCADO_WITH_CHECKLIST, alocado);
  } else {
    services.programacaoAbate
      .deleteSlaughterProgrammingAllocatedLots({
        pk: alocado.idProgramacaoAbateAlocado,
      })
      .then(() => {
        SlaughterProgrammingEventBus.$emit("reset-lots-list-dialog");
        commit(types.REMOVE_LOTE_ALOCADO_WITHOUT_CHECKLIST, alocado);
      });
  }
};

export const ActionRecoverDeletedBatchAllocated = ({ commit }, alocado) => {
  commit(types.RECOVER_LOTE_ALOCADO_WITH_CHECKLIST, alocado);
};

export const ActionLoadCheckList = ({ commit }, programacaoAbateAlocado) => {
  const params = {
    cdProgramacaoAbateAlocado:
      programacaoAbateAlocado.idProgramacaoAbateAlocado,
  };
  return services.programacaoAbate
    .loadCheckListProgramacaoAbateAlocado(params)
    .then((resp) => {
      if (resp.data[0].data) {
        let result = {
          checkList: resp.data[0].data,
          cdProgramacaoAbateAlocado:
            programacaoAbateAlocado.idProgramacaoAbateAlocado,
        };
        commit(types.SET_CHECK_LIST_PROGRAMACAO_ABATE_ALOCADO, result);
      }
    })
    .catch((error) => {
      // commit(types.SET_ERROR, error);
    });
};

export const ActionChangePeriodoAbateValueItem = (
  { commit, dispatch },
  item
) => {
  commit(types.SET_NEW_VALUE_PERIODO_CARREGAMENTO_CHECKLIST, item);
  let recCheckList = item.valueCheckList;
  recCheckList.stAbatePeriodo = item.stAbatePeriodo;
  dispatch("ActionUpdateCheckListAbateAlocado", recCheckList);
};

export const ActionUpdateCheckListAbateAlocado = (
  { commit, state },
  itemCheckList
) => {
  return services.programacaoAbate
    .updateCheckListAbate(
      { id: itemCheckList.idCheckList },
      {
        stAbatePeriodo: itemCheckList.stAbatePeriodo,
      }
    )
    .then((resp) => {
      const data = resp.data[0].data;
    })
    .catch((error) => {
      // commit(types.SET_ERROR, error);
    })
    .finally(() => {
      commit(types.SET_LOADING, false);
    });
};

export const ActionChangePeriodoCarregamentoValueItem = (
  { commit, dispatch },
  item
) => {
  let recCheckList = item.valueCheckList;
  recCheckList.stCarregamentoPeriodo = item.sgPeriodoCarregamento || null;
  recCheckList.dtCarregamento = item.dtCarregamento;
  recCheckList.hrInicioJejum = item.hrInicioJejum;
  dispatch("ActionUpdateCheckListCarregamentoAlocado", recCheckList);
};

export const ActionUpdateCheckListCarregamentoAlocado = (
  { commit, state },
  itemCheckList
) => {
  return services.programacaoAbate
    .updateCheckListCarregamento(
      { id: itemCheckList.idCheckList },
      {
        dtCarregamento: itemCheckList.dtCarregamento,
        stCarregamentoPeriodo: itemCheckList.stCarregamentoPeriodo,
        hrInicioJejum: itemCheckList.hrInicioJejum
      }
    )
    .then((resp) => {
      const data = resp.data[0].data;
    })
    .catch((error) => {
      // commit(types.SET_ERROR, error);
    })
    .finally(() => {
      commit(types.SET_LOADING, false);
    });
};

export const setLoteAlocadoQtAnimais = (
  { commit },
  { idProgramacaoAbateAlocado, value }
) => {
  commit(types.SET_LOTE_ALOCADO_QT_ANIMAIS, {
    idProgramacaoAbateAlocado,
    value,
  });
};

export const setLoteAlocadoNrPeso = (
  { commit },
  { idProgramacaoAbateAlocado, value }
) => {
  commit(types.SET_LOTE_ALOCADO_NR_PESO, {
    idProgramacaoAbateAlocado,
    value,
  });
};

export const ActionRemoveAllocatedLots = ({ commit, state }, lotsToRemove) => {
  if (!lotsToRemove.length) return;
  return services.programacaoAbate
    .deleteSlaughterProgrammingAllocatedLots({
      pk: lotsToRemove.join(","),
    })
    .then(() => {
      SlaughterProgrammingEventBus.$emit("reset-lots-list-dialog");
      commit(types.CLEAR_LOTE_ALOCADO_LIST);
    });
};

export const actionClearAllInfos = ({ commit }) => {
  commit(types.CLEAR_ALL);
};

export const actionChangeDialogLotList = ({ commit }, value) => {
  commit(types.CHANGE_DIALOG_BATCHS_AVALIABLE, value);
};

export const ActionCopyProgAbateAlocado = (
  { commit },
  { idProgramacaoAbateAlocado }
) => {
  commit(types.SET_CUTTING, false);
  commit(types.SET_COPYING, true);
  commit(
    types.SET_ID_PROGRAMACAO_ABATE_ALOCADO_TO_COPY,
    idProgramacaoAbateAlocado
  );
};

export const ActionCutProgAbateAlocado = (
  { commit },
  { idProgramacaoAbateAlocado }
) => {
  commit(types.SET_COPYING, false);
  commit(types.SET_CUTTING, true);
  commit(
    types.SET_ID_PROGRAMACAO_ABATE_ALOCADO_TO_COPY,
    idProgramacaoAbateAlocado
  );
};

const verifyBatchAllocatedExistsByDay = (state, stDiaAlocado, cdPlantaAbate) => {
  const foundLot = state.listBatchsAllocated.find(
    (item) =>
      item["idProgramacaoAbateAlocado"] ===
      state.idProgramacaoAbateAlocadoToCopy
  );
  if (foundLot) {
    const idx = state.listBatchsAllocated.findIndex(
      (item) =>
        item["cdLoteProducao"] === foundLot["cdLoteProducao"] &&
        item["stDiaAlocado"] === stDiaAlocado &&
        item["cdPlantaAbate"] === cdPlantaAbate
    );
    return idx > -1;
  }
  return false;
};

export const ActionPasteProgAbateAlocado = (
  { state, commit, dispatch },
  { dtAlocado, stDiaAlocado, cdPlantaAbate, nrPesoDia }
) => {
  if (verifyBatchAllocatedExistsByDay(state, stDiaAlocado, cdPlantaAbate)) {
    commit(
      "setSnack",
      {
        type: "error",
        msg: "Esse lote já está alocado no dia selecionado",
      },
      { root: true }
    );
    commit(types.CLEAR_PROGAMACAO_ABATE_ALOCADO_TO_COPY);
    return
  } else {
    if (state.isCutting) {
      commit(types.PASTE_PROGAMACAO_ABATE_ALOCADO, {
        stDiaAlocado,
        cdPlantaAbate,
        dtAlocado: moment(dtAlocado, "DD/MM/YYYY").format("YYYY-MM-DD"),
        nrPesoDia
      });
    } else {
      const foundLot = state.listBatchsAllocated.find(
        (item) =>
          item["idProgramacaoAbateAlocado"] ===
          state.idProgramacaoAbateAlocadoToCopy
      );
      if (foundLot) {
        const payload = [
          {
            cd_programacao_abate: foundLot.cdProgramacaoAbate,
            cd_lote_producao: foundLot.cdLoteProducao,
            cd_planta_abate: cdPlantaAbate,
            st_dia_alocado: stDiaAlocado,
            dt_alocado: moment(dtAlocado, "DD/MM/YYYY").format("YYYY-MM-DD"),
            nr_peso_dia: nrPesoDia,
            qt_animais_alocados: 0,
          },
        ];
        services.programacaoAbate
          .insertSlaughterProgrammingAllocatedLots(payload)
          .then(() => {
            commit("setSnack", {
              type: "success",
              msg: "Lotes alocados com sucesso"
            }, { root: true });
            dispatch("ActionLoadBatchsAllocated", foundLot.cdProgramacaoAbate);
            commit(types.CLEAR_PROGAMACAO_ABATE_ALOCADO_TO_COPY);
          });
      }
    }
  }

  commit(types.SET_COPYING, false);
  commit(types.SET_CUTTING, false);
};

export const ActionCancelPasteProgAbateAlocado = ({commit}) => {
  commit(types.CLEAR_PROGAMACAO_ABATE_ALOCADO_TO_COPY);
}
